// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CnL1","right":"styles_right__1ojDG"};